// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__3M-Cf","header":"ClearentDisclaimer_header__eADrm","inner":"ClearentDisclaimer_inner__3ogAr"};